import * as React from "react";
import * as ReactDOM from "react-dom";
import * as Rest from "../../Generated/RestClient";
import { SupportedFeatureUtility } from "../Utility/SupportedFeatureUtility";

export interface AccountSettingsProps {
    user: Rest.AuthData;
    deleteAccount: (user: Rest.AuthData) => void;
}

export interface AccountSettingState {
    allowDelete: boolean;
}

export class AccountSettingsPage extends React.Component<AccountSettingsProps, AccountSettingState> {
    constructor(props) {
        super(props);
        this.state = {
            allowDelete: false
        };
    }

    public render() {
        if (!this.props.user) {
            return <div style={{ margin: '20px auto', width: 64 }}>
                <div className="m-spinner-six">
                    <span></span>
                    <span></span>
                    <span></span>
                    <span></span>
                    <span></span>
                    <span></span>
                </div>
            </div>;
        }

        const deleteAccountAllowed = SupportedFeatureUtility.isSupported(Rest.DevPortalFeatureFlags.SupportNonAzureUsers);
        if (!deleteAccountAllowed) {
            return <div style={{ margin: '20px auto', width: '80%' }}>
                <div>
                    <h1 className="m-header-1">Account settings</h1>
                </div>
                <div>
                    <h2 className="m-header-2" style={{ marginTop: 30 }}>You cannot manage your account in this environment.</h2>
                </div>
            </div>;
        }

        return <div style={{ margin: '20px auto', width: '80%' }}>
            <div>
                <h1 className="m-header-1">Account settings</h1>
            </div>

            <div>
                <h2 className="m-header-2" style={{ marginTop: 30 }}>Danger Zone</h2>
                <p style={{ color: "#750b1c" }}>
                    Warning: Following operation may result in data loss and is not recoverable. Please be certain.
                </p>
                <label className="m-label">
                    If you are sure you want to delete your account, please enter {this.props.user.EmailAddress} in following field:
                </label>
                <input
                    onChange={e => this.onEmailChange(e)}
                    type="text"
                    placeholder="Confirm email"
                    style={{ marginBottom: 30 }}
                    className="m-input">
                </input>
                <button
                    onClick={() => this.props.deleteAccount(this.props.user)}
                    className="m-button-destructive-md"
                    disabled={!this.state.allowDelete}>
                    Delete your account
                </button>
            </div>
        </div>;
    }

    private onEmailChange(e: React.ChangeEvent<HTMLInputElement>) {
        const allowDelete = this.props.user && e.currentTarget.value === this.props.user.EmailAddress;
        const newState = _.extend({}, this.state, { allowDelete });
        this.setState(newState);
    }
}



// WEBPACK FOOTER //
// ./Client/v4/Views/AccountSettingsPage.tsx